<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true"
      [customBack]="'concierge'" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      @if (modalState === 'LIST') {
        <concierge-filter
          [addresses]="addressResponse"
          [buttonTitle]="pageTitle === 'Support Requests' ? 'Add Request' : 'Add Action'"
          (onFilter)="onFilterChanges($event)"
          (onSearch)="onSearchChanges($event)"
          (onAddItem)="addItem()" />
      }
      @if (wasTableLoaded && modalState === 'LIST') {
        @for (item of currentRows; track item) {
          <tidy-card>
            <tidy-card-button (action)="onTableColumnClick(item)">
              <tidy-row class="vertical-align-middle">
                <tidy-image
                  [src]="item['Status']?.value?.includes('dispute') ? concierge.getDisputeIcon(item['Status']?.value) : 'assets/img/support-request.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="item['Subject']?.value" />
              </tidy-row>
              @if (!item['Status']?.value?.includes('dispute')) {
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [smallBody]="item['Status'].value + (' (updated ' | translate) + item['Last Updated'].value + ')'" />
                </tidy-row>
              }
            </tidy-card-button>
          </tidy-card>
        }
        <mat-paginator
          style="background: none"
          [length]="totalItems"
          [pageSize]="5"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="selectPage($event)" />
      }
      @if (modalState === 'ADD') {
        @if (newItemType !== 'support.concierge_task') {
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="itemTypeHeader(newItemType)" />
          </tidy-row>
        }
        @if (newItemType === 'support.concierge_task') {
          <tidy-row>
            <tidy-text
              [body]="'Concierge Actions are where you can specify anything you need from TIDY. Our AI and concierge teams will figure out how to get it done for you. We accept anything relating to coordinate cleaning and maintenance at your properties.'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'<b>Examples:</b>'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Can you add this checklist to my account?'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Can you set up 3 vendors to come and clean the carpets, complete a regular cleaning, and complete an inspection?'" />
          </tidy-row>
        }
        @if (newItemType === 'support.how_to') {
          <tidy-row>
            <tidy-text
              [body]="'We expect to reply within 2 business hours. We will reply both in the app and to your email'" /><span>&nbsp;</span>
              <tidy-text
                [body]="email" />
            </tidy-row>
          }
          <tidy-card>
            <form [formGroup]="itemForm" novalidate action="#">
              <tidy-row>
                <tidy-textarea
                  [label]="getSubjectFieldLabel()"
                  [icon]="'assets/svg/checkbox-outline.svg'"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a subject'"
                  [form]="itemForm.get('subject')"
                  formControlName="subject" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-textarea
                  label="Description"
                  [icon]="'assets/svg/create-outline.svg'"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a description'"
                  [form]="itemForm.get('body')"
                  formControlName="body" />
              </tidy-row>
              @if (attachments.length) {
                <tidy-row class="field-top-padding">
                  @for (attachment of attachments; track attachment; let i = $index) {
                    <tidy-two-column-row>
                      <tidy-text
                        [body]="attachment.filename" />
                      <tidy-text
                        [actionBody]="'remove'"
                        (action)="removeAttachment(i)"
                        class="link red" />
                    </tidy-two-column-row>
                  }
                </tidy-row>
              }
              <tidy-row>
                <tidy-text
                  [actionBody]="'Add Attachment'"
                  (action)="addAttachment()"
                  class="link" />
              </tidy-row>
            </form>
          </tidy-card>
          <tidy-button
            [text]="'Send to Concierge'"
            [action]="boundSaveItem"
            class="primary" />
        }
        @if (modalState === 'EDIT') {
          <tidy-row class="vertical-align-middle">
            <tidy-image
              [src]="editingItem.components[0].value.status === 'closed' ? 'assets/img/done.svg' : 'assets/img/pending.svg'"
              class="header-size" />
            @if (editingItem.type !== 'support.concierge_task') {
              <tidy-text
                [body]="editingItem?.header_text" />
            }
            @if (editingItem.type === 'support.concierge_task') {
              <tidy-text
                [body]="editingItem?.components[0]?.value?.subject" />
            }
          </tidy-row>
          <!--<tidy-row *ngIf="status !== 'completed' && status !== 'closed'">
          <tidy-text
            [smallHelper]="(editingItem?.components[0]?.value?.status == 'waiting_on_customer' ? ('Waiting on you' | translate) : ('Waiting on TIDY' | translate)) + (' (updated ' | translate) + (editingItem?.components[0]?.value?.last_update_at | parseDate: 'MMM d h:mma') + ')'">
          </tidy-text>
        </tidy-row>-->
        @if (status === 'waiting_on_tidy' && editingItem.type !== 'support.concierge_task') {
          <tidy-row class="extra-top-padding">
            <tidy-text
              [body]="'We expect to reply within'" /><span>&nbsp;</span>
              <tidy-text
                [body]="replyTime" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'We will reply both in the app and to your email'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="email + '.'" />
                </tidy-row>
              }
              @if (status === 'waiting_on_tidy' && editingItem.type === 'support.concierge_task') {
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [body]="'Our concierge will complete the task or reach out with any questions.'" />
                </tidy-row>
              }
              @for (comment of editingItem?.components[0]?.value?.comments; track comment) {
                <tidy-card>
                  <tidy-row class="vertical-align-center">
                    @if (comment?.user_type === 'Customer' || comment?.user_type === 'customer') {
                      <tidy-initials-icon
                        [fullName]="comment?.user_first_name + (comment?.user_last_name ? comment?.user_last_name : '')" />
                    }
                    @if (comment?.user_type !== 'Customer' && comment?.user_type !== 'customer') {
                      <tidy-image
                        [src]="'assets/img/concierge.svg'"
                        class="header-size" />
                    }
                    <tidy-text
                      [body]="(comment?.user_type === 'Customer' || comment?.user_type === 'customer') ? comment?.user_first_name : 'TIDY Concierge'" />
                    <tidy-text
                      [smallHelper]="(comment?.created_at | parseDateTime:'MMM d':'local') + ' ' + (comment?.created_at | parseDateTime:'h:mma':'local')"
                      style="margin-left: 8px" />
                  </tidy-row>
                  @if (comment?.content) {
                    <tidy-row>
                      <tidy-markdown
                        [markdownContent]="comment?.content" />
                    </tidy-row>
                  }
                </tidy-card>
              }
              @if (displayedAttachments?.length > 0) {
                <tidy-row>
                  <tidy-text
                    [header]="'Attachments:'" />
                </tidy-row>
                <div class="attachment-container">
                  @for (attachment of displayedAttachments; track attachment) {
                    <tidy-row>
                      @if (isImageUrl(attachment.fileUrl)) {
                        <img
                          [src]="attachment.fileUrl"
                          (click)="openAttachment(attachment.fileUrl)"
                          class="attachment-image">
                      }
                      @if (!isImageUrl(attachment.fileUrl)) {
                        <tidy-text
                          [body]="attachment.filename"
                          (click)="openAttachment(attachment.fileUrl)"
                          class="link" />
                      }
                    </tidy-row>
                  }
                </div>
              }
              <tidy-row class="field-top-padding" style="padding-top: 3px">
                <form [formGroup]="replyForm" novalidate action="#">
                  <tidy-textarea
                    #replyTextArea
                    [label]="'Reply'"
                    formControlName="content"
                    [form]="replyForm.controls.content"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter a reply.'"
                    [rightIconAction]="boundSendReply"
                    [leftIconAction]="boundAddAttachment"
                    [attachmentIcon]="'attach_file'" />
                </form>
              </tidy-row>
              @if (errorMessage) {
                <tidy-error-message
                  [text]="errorMessage" />
              }
            }
            @if (modalState === 'SELECT_TYPE') {
              <tidy-card-button (action)="selectType('support.how_to')">
                <tidy-grid>
                  <tidy-row>
                    <ion-row>
                      <ion-col size="2" class="vertical-align-center">
                        <div style="margin: auto">
                          <tidy-image
                            [src]="'assets/img/home-heart.svg'"
                            style="width:25px" />
                        </div>
                      </ion-col>
                      <ion-col>
                        <tidy-row>
                          <tidy-text
                            [header]="'How to Use TIDY'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="'Ask a question about TIDY.'" />
                        </tidy-row>
                      </ion-col>
                    </ion-row>
                  </tidy-row>
                </tidy-grid>
              </tidy-card-button>
              <tidy-card-button (action)="jobIssue()">
                <tidy-grid>
                  <tidy-row>
                    <ion-row>
                      <ion-col size="2" class="vertical-align-center">
                        <div style="margin: auto">
                          <tidy-image
                            [src]="'assets/img/repair-tools.svg'"
                            style="width:25px" />
                        </div>
                      </ion-col>
                      <ion-col>
                        <tidy-row>
                          <tidy-text
                            [header]="'Issue with a Job'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="'Notify us of an issue with a job/pro.'" />
                        </tidy-row>
                      </ion-col>
                    </ion-row>
                  </tidy-row>
                </tidy-grid>
              </tidy-card-button>
              <tidy-card-button (action)="billingIssue()">
                <tidy-grid>
                  <tidy-row>
                    <ion-row>
                      <ion-col size="2" class="vertical-align-center">
                        <div style="margin: auto">
                          <tidy-image
                            [src]="'assets/img/billing-issue.svg'"
                            style="width:25px" />
                        </div>
                      </ion-col>
                      <ion-col>
                        <tidy-row>
                          <tidy-text
                            [header]="'Issue with Billing'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="'Ask us a question about charges or credits.'" />
                        </tidy-row>
                      </ion-col>
                    </ion-row>
                  </tidy-row>
                </tidy-grid>
              </tidy-card-button>
              <tidy-card-button (action)="selectType('support.other')">
                <tidy-grid>
                  <tidy-row>
                    <ion-row>
                      <ion-col size="2" class="vertical-align-center">
                        <div style="margin: auto">
                          <tidy-image
                            [src]="'assets/img/help.svg'"
                            style="width:25px" />
                        </div>
                      </ion-col>
                      <ion-col>
                        <tidy-row>
                          <tidy-text
                            [header]="'Other'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="'Note: The slowest option'" />
                        </tidy-row>
                      </ion-col>
                    </ion-row>
                  </tidy-row>
                </tidy-grid>
              </tidy-card-button>
            }
            @if (modalState === 'SELECT_JOB') {
              <tidy-row [align]="'center'">
                <tidy-text
                  [body]="'Which job did you have an issue with?'" />
              </tidy-row>
              <tidy-card>
                @for (job of pastJobsResponse | slice:0:showLimiter; track job) {
                  <tidy-card-button (action)="selectJob(job)">
                    <tidy-row>
                      <tidy-text
                        [body]="job?.service" />
                      <tidy-text
                        [body]="(' on ' | translate) + (job?.start_datetime_local | parseDateTime: 'ddd MMM d') + ' ' + (job?.start_datetime_local | parseDateTime: 'h:mma')" />
                      <br>
                        <tidy-text
                          [helper]="job?.display_address" />
                      </tidy-row>
                    </tidy-card-button>
                  }
                  <tidy-card-button (action)="selectJob()">
                    <tidy-row>
                      <tidy-text
                        [body]="'Not Listed'" />
                    </tidy-row>
                  </tidy-card-button>
                  @if (pastJobsResponse.length > 10) {
                    <tidy-card-button (action)="showLimit()">
                      <tidy-row>
                        @if (showLimiter == 10) {
                          <tidy-text
                            [body]="'Show more jobs'" />
                        }
                        @if (showLimiter !== 10) {
                          <tidy-text
                            [body]="'Show less jobs'" />
                        }
                      </tidy-row>
                    </tidy-card-button>
                  }
                </tidy-card>
              }
              @if (modalState === 'SELECT_JOB_SUBTYPE') {
                <tidy-card>
                  <tidy-row [align]="'center'" class="extra-bottom-padding">
                    <tidy-text
                      [body]="'This job on'" /><span>&nbsp;</span>
                      <tidy-text
              [body]="(itemMetadata?.job?.job?.date | parseDateTime: 'ddd') + ' ' + (itemMetadata?.job?.job?.date | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="'at'" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="itemMetadata?.job?.job?.start_time | parseDateTime: 'h:mma'" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="'is marked as'" /><span>&nbsp;</span>
                              <tidy-text
                                [body]="itemMetadata.jobStatus + '. '" />
                              <tidy-text
                                [body]="'What is your issue?'" />
                            </tidy-row>
                            <tidy-card-button (action)="selectJobIssueSubtype('bad_quality')">
                              <tidy-row>
                                <tidy-text
                                  [body]="'The service quality was bad'" />
                              </tidy-row>
                            </tidy-card-button>
                            <tidy-card-button (action)="selectJobIssueSubtype('no_show')">
                              <tidy-row>
                                <tidy-text
                                  [body]="'The pro never showed up'" />
                              </tidy-row>
                            </tidy-card-button>
                            <tidy-card-button (action)="selectJobIssueSubtype('damage_claim')">
                              <tidy-row>
                                <tidy-text
                                  [body]="'Something is damaged'" />
                              </tidy-row>
                            </tidy-card-button>
                            <tidy-card-button (action)="selectJobIssueSubtype('tip')">
                              <tidy-row>
                                <tidy-text
                                  [body]="'I want to leave a tip'" />
                              </tidy-row>
                            </tidy-card-button>
                            <tidy-card-button (action)="selectJobIssueSubtype('other_issue')">
                              <tidy-row>
                                <tidy-text
                                  [body]="'Other service issue (slowest)'" />
                              </tidy-row>
                            </tidy-card-button>
                          </tidy-card>
                        }
                        @if (modalState === 'BILLING_ISSUE') {
                          <tidy-card>
                            <tidy-row>
                              <tidy-text
                                header="Billing Issue" />
                            </tidy-row>
                            <tidy-row [align]="'center'" class="extra-bottom-padding">
                              <tidy-text
                                body='We are happy to help with any billing issues. Please tap "Need help?" on the billing item you have questions on, and we typically help within 4 business hours.' />
                            </tidy-row>
                            <tidy-button
                              [text]="'View Billing History'"
                              [action]="boundBillingHistory"
                              class="secondary" />
                          </tidy-card>
                        }
                      }
                    </tidy-wrapper>
                  </ng-template>

                  @if (!windowService.isDesktopRes) {
                    <app-scroll-wrapper [templateContent]="content" />
                  }

                  @if (windowService.isDesktopRes) {
                    <ion-content class="ion-content-right-column">
                      <ng-container *ngTemplateOutlet="content" />
                    </ion-content>
                  }
